'use strict';

window.addEventListener('DOMContentLoaded', function () {
	new ScrollClasses(document.body, [{
		'scrolled': 90,
		'class': 'scrolled-down'
	}]);
});